/**
 * The key for the oracle prices in the local storage
 */
export const ORACLE_PRICES_KEY = 'oracle-prices';
